var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tblAlarmHistory__wrapper"},[_c('b-table',{attrs:{"id":"tabel-alarm","fields":_vm.fields,"items":_vm.model,"tbody-tr-class":_vm.rowClass,"sticky-header":"100%","bordered":"","small":"","responsive":""},scopedSlots:_vm._u([{key:"cell(startDate)",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getDate(item.StartTime))+" ")]}},{key:"cell(startTime)",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getTime(item.StartTime))+" ")]}},{key:"cell(StartValue)",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getComingValue(item))+" ")]}},{key:"cell(endDate)",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getDate(item.EndTime))+" ")]}},{key:"cell(endTime)",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getTime(item.EndTime))+" ")]}},{key:"cell(EndValue)",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getGoingValue(item))+" ")]}},{key:"cell(duration)",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getDuration(item))+" ")]}},{key:"cell(ackDate)",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getDate(item.AckTime))+" ")]}},{key:"cell(ackTime)",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getTime(item.AckTime))+" ")]}},{key:"cell(AckValue)",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getAckValue(item))+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }